import "@mantine/carousel/styles.css";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "dayjs/locale/fr";
import "./i18n";
import "./index.css";

import { isDev } from "@helpers/utils";
import * as Sentry from "@sentry/react";
import dayjs from "dayjs";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import router from "./react-router.config";
import { sentryConfig } from "./sentry.config";

dayjs.locale("fr");

if (!isDev()) {
  Sentry.init(sentryConfig);
}

const AppRouter = () => {
  return <RouterProvider router={router} />;
};

// biome-ignore lint/style/noNonNullAssertion: should exist
createRoot(document.getElementById("root")!).render(<AppRouter />);
